// UI copy shared by the portal and public surveys. Customer content is never translated.
export const portalEN = {
  question_option_label: 'Option {{option}} of question {{question}}',
  surveys: 'Surveys',
  survey: 'Survey',
  listen_to_your_customers_and_assign_tags_after_submission:
    'Listen to your customers and assign tags after submission.',
  select_a_venue_to_manage_surveys: 'Select a venue to manage surveys.',
  create_survey: 'Create survey',
  edit_survey: 'Edit survey',
  search_surveys_by_name: 'Search surveys by name',
  search_for_a_survey_by_name: 'Search for a survey by name…',
  no_surveys_found: 'No surveys found',
  create_your_first_survey_to_collect_feedback_and_ratings:
    'Create your first survey to collect feedback and ratings.',
  published: 'Published',
  paused_draft: 'Paused / draft',
  responses: 'Responses',
  rating: 'Rating',
  none_yet: 'None yet',
  customer_link: 'Customer link',
  surveys_2: ' surveys',
  questions: 'questions ·',
  tags: 'tags',
  responses_2: 'responses',
  survey_saved: 'Survey saved',
  save_survey: 'Save survey',
  write_your_questions_a_five_star_rating_is_always_included_at_the_end:
    'Write your questions. A five-star rating is always included at the end.',
  survey_name: 'Survey name *',
  e_g_how_was_your_dinner: 'E.g. How was your dinner?',
  introduction_for_the_customer: 'Introduction for the customer',
  tags_to_add_after_submission: 'Tags to add after submission',
  these_are_added_to_the_customer_s_tags_without_removing_existing_ones:
    'These are added to the customer’s tags without removing existing ones.',
  loading_tags: 'Loading tags…',
  select_venue_tags: 'Select venue tags',
  question_and_answer_tags_are_not_yet_supported_by_the_connected_service_you_can_confi:
    'Question and answer tags are not yet supported by the connected service. You can configure them here, but saving requires a service update.',
  question_and_answer_tags_require_an_update_to_the_connected_service_the_survey_was_no:
    'Question and answer tags require an update to the connected service. The survey was not saved.',
  enter_a_name_question_text_and_at_least_two_distinct_options_for_choice_questions:
    'Enter a name, question text and at least two distinct options for choice questions.',
  question: 'Question',
  question_text: 'Question text *',
  answer_type: 'Answer type',
  text_answer: 'Text answer',
  single_choice_one_answer: 'Single choice — one answer',
  multiple_choice_several_answers: 'Multiple choice — several answers',
  question_tags: 'Question tags',
  added_when_the_customer_answers_this_question:
    'Added when the customer answers this question.',
  no_tags_for_this_question: 'No tags for this question',
  answer_options_2_to_20: 'Answer options (2 to 20)',
  tags_when_the_customer_selects_this_answer:
    'Tags when the customer selects this answer',
  select_tags_for_this_answer: 'Select tags for this answer',
  add_option: 'Add option',
  remove_option: 'Remove option',
  required_answer: 'Required answer',
  add_question: 'Add question',
  move_question_up: 'Move question up',
  move_question_down: 'Move question down',
  remove_question: 'Remove question',
  final_rating_from_1_to_5_stars: 'Final rating from 1 to 5 stars',
  the_customer_selects_a_star_rating_before_submitting_the_survey:
    'The customer selects a star rating before submitting the survey.',
  publish_survey: 'Publish survey',
  when_disabled_links_no_longer_accept_responses_existing_responses_remain_saved:
    'When disabled, links no longer accept responses. Existing responses remain saved.',
  survey_preview: 'Survey preview',
  create_a_customer_link: 'Create a customer link',
  search_customers_by_name_email_or_code:
    'Search customers by name, email or code',
  type_at_least_2_characters: 'Type at least 2 characters…',
  searching: 'Searching…',
  no_customers_found: 'No customers found.',
  generate_customer_link: 'Generate customer link',
  this_link_associates_the_response_with_the_selected_customer:
    'This link associates the response with the selected customer.',
  survey_link: 'Survey link',
  link_copied: 'Link copied',
  copy_the_link_manually_from_the_field_above:
    'Copy the link manually from the field above.',
  loading_responses: 'Loading responses…',
  you_have_not_received_any_responses_yet:
    'You have not received any responses yet.',
  tags_added: 'Tags added:',
  the_request_could_not_be_completed: 'The request could not be completed.',
  your_opinion_matters: 'Your opinion matters',
  the_link_is_incomplete_ask_the_venue_for_a_new_link:
    'The link is incomplete. Ask the venue for a new link.',
  this_survey_is_unavailable_ask_the_venue_for_a_new_link:
    'This survey is unavailable. Ask the venue for a new link.',
  we_could_not_load_the_survey_please_try_again:
    'We could not load the survey. Please try again.',
  loading_failed: 'Loading failed.',
  the_survey_has_been_updated_please_review_the_questions:
    'The survey has been updated. Please review the questions.',
  check_your_answers_and_choose_a_rating_from_1_to_5_stars:
    'Check your answers and choose a rating from 1 to 5 stars.',
  submission_failed_please_try_again_shortly:
    'Submission failed. Please try again shortly.',
  submission_failed: 'Submission failed.',
  your_voice_helps_us_grow: 'Your voice helps us grow',
  a_moment_to_listen: 'A MOMENT TO LISTEN',
  your_feedback_makes_a_difference: 'Your feedback makes a difference.',
  preparing_your_survey: 'Preparing your survey…',
  responses_sent: 'RESPONSES SENT',
  thank_you_for_your_feedback: 'Thank you for your feedback!',
  your_answers_have_been_recorded_thank_you_for_taking_the_time_to_help_us_improve:
    'Your answers have been recorded. Thank you for taking the time to help us improve.',
  tell_us_about_your_experience: 'Tell us about your experience',
  answer_the_questions_and_leave_your_final_rating:
    'Answer the questions and leave your final rating.',
  your_answers_are_linked_to_your_customer_profile:
    'Your answers are linked to your customer profile.',
  powered_by: 'Powered by',
  optional: ' (optional)',
  write_your_answer_here: 'Write your answer here…',
  choose_one_answer: 'Choose one answer.',
  you_can_choose_several_answers: 'You can choose several answers.',
  how_would_you_rate_your_experience: 'How would you rate your experience? *',
  choose_from_1_to_5_stars: 'Choose from 1 to 5 stars.',
  no_rating_selected: 'No rating selected',
  submit_your_feedback: 'Submit your feedback',
  text_answers_can_contain_up_to_5_000_characters:
    'Text answers can contain up to 5,000 characters.',
  choose_a_valid_answer: 'Choose a valid answer.',
  choose_only_the_available_options: 'Choose only the available options.',
  choose_a_rating_from_1_to_5_stars: 'Choose a rating from 1 to 5 stars.',
  complete_the_question_value: 'Complete the question: {{question}}',
  value_out_of_5_stars: '{{count}} out of 5 stars',
  value_stars: '{{count}} stars',
  value_questions_value_tags: '{{count}} questions · {{tags}} tags',
  value_responses: '{{count}} responses',
  value_surveys: '{{count}} surveys',
  value_questions_rating: '{{count}} questions + rating',
  responses_value: 'Responses · {{name}}',
};
